import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useDoc } from '@/composables/useDoc';
import { TabType } from '@/store/modules/types';
import { ref, watch } from 'vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'TabTypeToggler',
  setup(__props) {

const isFrench = ref(useDoc().getTabType() == TabType.FRENCH);
watch(isFrench, val => {
    useDoc().setTabType(val == true ? TabType.FRENCH : TabType.ITALIAN)
})


return (_ctx: any,_cache: any) => {
  const _component_VaSwitch = _resolveComponent("VaSwitch")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_VaSwitch, {
      modelValue: isFrench.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isFrench).value = $event)),
      color: "success",
      "true-inner-label": "French",
      "false-inner-label": "Italian",
      "off-color": "success",
      style: {"--va-switch-checker-background-color":"#fff"}
    }, null, 8, ["modelValue"]),
    _createVNode(_component_va_button, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(useDoc)().updateUI()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_va_icon, { name: "refresh" })
      ]),
      _: 1
    })
  ]))
}
}

})